<template>
  <div
    class="schedule-grid"
    :style="{ width: gridWidth + 'px', minWidth: gridWidth + 'px' }"
  >
    <template v-for="(roomEntry, rIdx) in roomsWithEmployees" :key="roomEntry.key">
      <ScheduleEmployeeColumn
        v-for="(emp, eIdx) in roomEntry.employees"
        :key="emp.user_id"
        :emp="emp"
        :timeMarks="timeMarks"
        :isLast="isLastColumn(rIdx, eIdx)"
        :colWidth="empColWidth"
        :slot-height="slotHeight"
        :appointments="appointments"
        :current-date="currentDate"
      />
    </template>
  </div>
</template>

<script>
import ScheduleEmployeeColumn from '@/components/util/calendar/ScheduleEmployeeColumn.vue'

export default {
  name: 'ScheduleGrid',
  components: { ScheduleEmployeeColumn },
  props: {
    roomsWithEmployees: { type: Array, required: true },
    timeMarks: { type: Array, required: true },
    empColWidth: { type: Number, default: 200 },
    slotHeight: { type: Number, default: 31 },
    appointments: { type: Array, default: () => [] },
    currentDate: { type: String, required: true }
  },
  computed: {
    gridWidth() {
      const count = this.roomsWithEmployees.reduce(
        (sum, room) => sum + room.employees.length, 0
      )
      return count * this.empColWidth
    }
  },
  methods: {
    isLastColumn(rIdx, eIdx) {
      const totalColumns = this.roomsWithEmployees.reduce(
        (sum, room) => sum + room.employees.length, 0
      )
      let idx = 0
      for (let i = 0; i < rIdx; i++) {
        idx += this.roomsWithEmployees[i].employees.length
      }
      idx += eIdx
      return idx === totalColumns - 1
    },
    getSlotHeight() {
      const interval = this.timeMarks[1] - this.timeMarks[0]
      return this.slotHeight * (interval / 15)
    }
  }
}
</script>

<style scoped>
.schedule-grid {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 0;
  position: relative;
}
</style>
